import { render } from "./layout-mobile.vue?vue&type=template&id=29fd1222"
import script from "./layout-mobile.vue?vue&type=script&lang=js"
export * from "./layout-mobile.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Barbara\\Angopri\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__